export default __webpack_public_path__ + "static/media/CafeAvion-7.a3c889ce.jpg";